import {DISCONTINUED_STATUS} from '~/assets/js/constants'

export function useDiscontinuedProduct() {

  const getSuccessorSku = (product: any): string | null => {
    const sku = product?.value?.salesAreas?.[0]?.successorSku ?? product?.salesAreas?.[0]?.successorSku ?? null
    return sku && sku !== '-' ? sku : null
  }

  const hasActiveSuccessor = (product: any): boolean => {
    const successorSku = getSuccessorSku(product)
    return successorSku !== null && successorSku !== undefined && successorSku !== ''
  }

  const isDiscontinuedWithSuccessorAndNoStock = (product: any, status: number, currentStockQuantity: number | null | undefined): boolean => {
    if (status !== DISCONTINUED_STATUS) {
      return false
    }

    const hasNoAtpStock = currentStockQuantity === 0 || currentStockQuantity === null || currentStockQuantity === undefined
    const hasSuccessor = hasActiveSuccessor(product)

    return hasNoAtpStock && hasSuccessor
  }

  const isDiscontinuedWithoutSuccessorAndNoStock = (product: any, status: number, currentStockQuantity: number | null | undefined): boolean => {
    if (status !== DISCONTINUED_STATUS) {
      return false
    }

    const hasNoAtpStock = currentStockQuantity === 0 || currentStockQuantity === null || currentStockQuantity === undefined
    const hasSuccessor = hasActiveSuccessor(product)

    return hasNoAtpStock && !hasSuccessor
  }

  const isDiscontinuedWithSuccessorAndStock = (product: any, status: number, currentStockQuantity: number | null | undefined): boolean => {
    if (status !== DISCONTINUED_STATUS) {
      return false
    }

    const hasNoAtpStock = currentStockQuantity === 0 || currentStockQuantity === null || currentStockQuantity === undefined
    const hasSuccessor = hasActiveSuccessor(product)

    return !hasNoAtpStock && hasSuccessor
  }

  const isDiscontinuedWithoutSuccessorAndStock = (product: any, status: number, currentStockQuantity: number | null | undefined): boolean => {
    if (status !== DISCONTINUED_STATUS) {
      return false
    }

    const hasNoAtpStock = currentStockQuantity === 0 || currentStockQuantity === null || currentStockQuantity === undefined
    const hasSuccessor = hasActiveSuccessor(product)

    return !hasNoAtpStock && !hasSuccessor
  }

  return {
    hasActiveSuccessor,
    getSuccessorSku,
    isDiscontinuedWithSuccessorAndNoStock,
    isDiscontinuedWithoutSuccessorAndNoStock,
    isDiscontinuedWithSuccessorAndStock,
    isDiscontinuedWithoutSuccessorAndStock
  }
}
